import { Navigate, Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import AuthGuard from "./AuthGuard";
import GuestGuard from "./GuestGuard";

// Layouts
import AuthLayout from "../components/layouts/AuthLayout";
import DashboardLayout from "../components/layouts/DashboardLayout";

import None from "../components/pages/none";

// Auth
import Login from "../components/pages/auth/login";
import Verification from "../components/pages/auth/verification";
import ResetOrCreatePass from "../components/pages/auth/resetOrCreatePass";
import ForgotPassword from "../components/pages/auth/forgotPassword";
import LoginWithOtp from "../components/pages/auth/loginWithOtp";

import Home from "../components/pages/dashboard/home";
import Settings from "../components/pages/dashboard/settings";
import UserManagement from "../components/pages/dashboard/settings/UserManagement";
import TeamManagement from "../components/pages/dashboard/teamManagement";
import EmployeeManagement from "../components/pages/dashboard/employeeManagement";
import Projects from "../components/pages/dashboard/projects";
import TaskManagement from "../components/pages/dashboard/taskManagement";
import EmployeeTaskManagement from "../components/pages/dashboard/employee/EmployeeTaskManagement";
import EmployeeProjects from "../components/pages/dashboard/employee/EmployeeProjectManagement";
import MyProfile from "../components/pages/dashboard/my-profile";
import ProjectTask from "../components/pages/dashboard/ProjectTask";
import Reports from "../components/pages/dashboard/reports";
import ClientManagement from "../components/pages/dashboard/settings/ClientManagement";
import Notifications from "../components/pages/dashboard/notificationsPage";
import DailyStatusReport from "../components/pages/dashboard/dailyStatusReport";
import StatusReportPage from "../components/pages/dashboard/StatusReportPage";
import TeamStatusReport from "../components/pages/dashboard/TeamStatusReport";
import ClientDashboard from "../components/pages/dashboard/ClientDashboard";
import ReportApproval from "../components/pages/dashboard/reportApproval";
import ProjectReportTask from "../components/pages/dashboard/ProjectReportTask";

// Dashboard

const routes = [
  {
    path: "/",
    element: <Navigate to="/auth" />,
  },
  {
    path: "auth",
    element: (
      <GuestGuard>
        <AuthLayout />
      </GuestGuard>
    ),
    children: [
      {
        index: true, // Make this the index route
        element: <Login />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "verify",
        element: <Verification />,
      },
      {
        path: "request-otp",
        element: <LoginWithOtp />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "reset-password",
        element: <ResetOrCreatePass type="reset" />,
      },
      {
        path: "create-password",
        element: <ResetOrCreatePass type="create" />,
      },
    ],
  },
  {
    path: "dashboard/*",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
  },
  {
    path: "employee/dashboard/*",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
  },
  {
    path: "none",
    element: <None />,
  },
];

export const dashboardRoute = (
  <Suspense>
    <Routes>
      <Route path="/" element={<Home />}></Route>
    </Routes>
    <Routes>
      <Route path="settings" element={<Settings />}></Route>
    </Routes>
    <Routes>
      <Route path="clientmanagement" element={<ClientManagement />}></Route>
    </Routes>
    <Routes>
      <Route path="employees" element={<EmployeeManagement />}></Route>
    </Routes>
    <Routes>
      <Route path="teams" element={<TeamManagement />}></Route>
    </Routes>
    <Routes>
      <Route path="projects" element={<Projects />}></Route>
    </Routes>
    <Routes>
      <Route path="project-reports" element={<ReportApproval />}></Route>
    </Routes>
    <Routes>
      <Route
        path="project-reports/projectreportinfo/:project_id"
        element={<ProjectReportTask />}
      ></Route>
    </Routes>
    <Routes>
      <Route path="projects/projectinfo/:id" element={<ProjectTask />}></Route>
    </Routes>
    <Routes>
      <Route path="tasks" element={<TaskManagement />}></Route>
    </Routes>
    <Routes>
      <Route path="my-tasks" element={<TaskManagement mytask={true} />}></Route>
    </Routes>
    <Routes>
      <Route path="my-profile" element={<MyProfile />}></Route>
    </Routes>
    <Routes>
      <Route path="reports" element={<Reports />}></Route>
    </Routes>
    <Routes>
      <Route path="client-report" element={<ClientDashboard />}></Route>
    </Routes>
    <Routes>
      <Route path="notifications" element={<Notifications />}></Route>
    </Routes>
    <Routes>
      <Route path="daily-status-report" element={<DailyStatusReport />}></Route>
    </Routes>
    <Routes>
      <Route path="team-status-report" element={<TeamStatusReport />}></Route>
    </Routes>
  </Suspense>
);

export const employeeDashboardRoute = (
  <Suspense>
    <Routes>
      <Route path="tasks" element={<TaskManagement />}></Route>
    </Routes>
    <Routes>
      <Route path="projects" element={<EmployeeProjects />}></Route>
    </Routes>
    <Routes>
      <Route path="my-profile" element={<MyProfile />}></Route>
    </Routes>
  </Suspense>
);

export default routes;
